import Vue from 'vue'
import Router from 'vue-router'
// import store from './store'
// import axios from 'axios'
Vue.use(Router)
let router = new Router({
    mode: 'history',
    routes: [{
        path: '/',
        props: true,
        component: () =>
            import('./components/MainPage'),
    },

    {
        path: '/page3',
        name: 'NextPage3',
        component: () => import('./components/NextPage3'),
    },
    {
        path: '/page4',
        name: 'MisionVisionPage',
        component: () => import('./components/MisionVisionPage'),
    },


    {
        path: '/page5',
        name: 'OrganisationStructurePage',
        component: () => import('./components/OrganisationStructurePage'),
    },
    {
        path: '/page6',
        name: 'MainPageSub',
        component: () => import('./components/MainPageSub'),
    },
    {
        path: '/page7',
        name: 'WorkingPlansPage',
        component: () => import('./components/WorkingPlansPage'),
    },
    {
        path: '/page8',
        name: 'MainPageSub2',
        component: () => import('./components/MainPageSub2'),
    },
    {
        path: '/page9',
        name: 'WorkPlanPageSub',
        component: () => import('./components/WorkPlanPageSub'),
    },
    {
        path: '/page10',
        name: 'WhosWhoPage',
        component: () => import('./components/WhosWhoPage'),
    },
    {
        path: '/page11',
        name: 'DivisionProfilePage',
        component: () => import('./components/DivisionProfilePage'),
    },

    {
        path: '/page12',
        name: 'HomeVanaSreePage',
        component: () => import('./components/VanaSreePage'),
    },
    {
        path: '/page13',
        name: 'vanshreeproductPage',
        component: () => import('./components/vanshreeproductPage'),
    },
    {
        path: '/page14',
        name: 'FloraPage',
        component: () => import('./components/FloraPage'),
    },
    {
        path: '/page15',
        name: 'FaunaPage',
        component: () => import('./components/FaunaPage'),
    },
    {
        path: '/page16',
        name: 'ForestAreaPage',
        component: () => import('./components/ForestAreaPage'),
    },

    {
        path: '/page17',
        name: 'ForestTypePage',
        component: () => import('./components/ForestTypePage'),
    },
    {
        path: '/page18',
        name: 'TribalSettlementPage',
        component: () => import('./components/TribalSettlementPage'),
    },
    {
        path: '/page19',
        name: 'TimberPage',
        component: () => import('./components/TimberPage'),
    },
    {
        path: '/page20',
        name: 'SopPage',
        component: () => import('./components/SopPage'),
    },
    {
        path: '/page21',
        name: 'GuidelinessPage',
        component: () => import('./components/GuidelinessPage'),
    },
    {
        path: '/page22',
        name: 'PublicationsPage',
        component: () => import('./components/PublicationsPage'),
    },
    {
        path: '/page23',
        name: 'BroachurePage',
        component: () => import('./components/BroachurePage'),
    },
    {
        path: '/page24',
        name: 'PoliciesPage',
        component: () => import('./components/PoliciesPage'),
    },
    {
        path: '/page25',
        name: 'CircularPage',
        component: () => import('./components/CircularPage'),
    },
    {
        path: '/page26',
        name: 'ScheduleRatespage',
        component: () => import('./components/ScheduleRatespage'),
    },
    {
        path: '/page27',
        name: 'ApplicationFormspage',
        component: () => import('./components/ApplicationFormspage'),
    },
    {
        path: '/page28',
        name: 'VolumeTablepage',
        component: () => import('./components/VolumeTablepage'),
    },
    {
        path: '/page29',
        name: 'ContactUspage1',
        component: () => import('./components/ContactUspage1'),
    },
    {
        path: '/page30',
        name: 'ContactUspage2',
        component: () => import('./components/ContactUspage2'),
    },
    {
        path: '/page31',
        name: 'ContactUspage3',
        component: () => import('./components/ContactUspage3'),
    },
    {
        path: '/page32',
        name: 'TransferandPoatingpage',
        component: () => import('./components/TransferandPoatingpage'),
    },
    {
        path: '/StaffStrengthPage',
        name: 'Home',
        component: () => import('./components/StaffStrengthPage'),
    },
    {
        path: '/page34',
        name: 'CodesAndManualspage',
        component: () => import('./components/CodesAndManualspage'),
    },
    // {
    //     path: '/page34',
    //     name: 'Home',
    //     component: () => import('./components/CodesAndManualspage'),
    // },
    {
        path: '/page35',
        name: 'VssPage',
        component: () => import('./components/VssPage'),
    },
    {
        path: '/page36',
        name: 'NatureCampPage',
        component: () => import('./components/NatureCampPage'),
    },
    {
        path: '/page37',
        name: 'FilimShootingPage',
        component: () => import('./components/FilimShootingPage'),
    },
    {
        path: '/page38',
        name: 'ResearchPage',
        component: () => import('./components/ResearchPage'),
    },
    {
        path: '/page39',
        name: 'FdaPage',
        component: () => import('./components/FdaPage'),
    },
    {
        path: '/page40',
        name: 'PfmPage',
        component: () => import('./components/PfmPage'),
    },
    {
        path: '/page41',
        name: 'AboutDivisionPage',
        component: () => import('./components/AboutDivisionPage'),
    },
    {
        path: '/page42',
        name: 'MankayamPage',
        component: () => import('./components/MankayamPage'),
    },
    {
        path: '/page43',
        name: 'KallarPage',
        component: () => import('./components/KallarPage'),
    },
    {

        path: '/page44',
        name: 'PonmudiPage',
        component: () => import('./components/PonmudiPage'),
    },
    {

        path: '/page45',
        name: 'DetailsofEco',
        component: () => import('./components/DetailsofEco'),
    },
    {

        path: '/page46',
        name: 'TendersPage',
        component: () => import('./components/TendersPage'),
    },
    {

        path: '/page47',
        name: 'GoverOrdersPage',
        component: () => import('./components/GoverOrdersPage'),
    },


    {

        path: '/page48',
        name: 'SawMillPage',
        component: () => import('./components/SawMillPage'),
    },


    {

        path: '/page49',
        name: 'LandRelated',
        component: () => import('./components/LandRelated'),
    },

    {

        path: '/page50',
        name: 'RightoInfo',
        component: () => import('./components/RightoInfo'),
    },


    {

        path: '/page51',
        name: 'PriceSchedule',
        component: () => import('./components/PriceSchedule'),
    },

    {

        path: '/page52',
        name: 'ContractSystem',
        component: () => import('./components/ContractSystem'),
    },
    {
        path: '*',
        name: 'PageNotFound',
        component: () =>
            import('./components/Common/checkValue'),
    },
    ],
    scrollBehavior() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0;
    },
});
export default router;